module.exports = __webpack_public_path__ + "img/banner-about.706dde4c.jpg";